import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ChatService from '../../../redux-toolkit/services/chatService/chatService'
import { initializeChatListeners, setTyping, stopTyping } from '../../../redux-toolkit/features/slices/chatSlice/chatSlice'
import axios from 'axios'
import { useGetSingleUserDataQuery } from '../../../redux-toolkit/services/UserAuthApi/UserAuthApi'
import { useGetChatDataQuery } from '../../../redux-toolkit/services/ChatApi/ChatApi'
import { SingleItem } from './SingleItem'
import ImageModal from './ImageModal';
import { IoIosArrowBack } from "react-icons/io";
import { HiBars4 } from "react-icons/hi2";
import { GrAttachment } from "react-icons/gr";
import { LuSendHorizontal } from "react-icons/lu";
import { IoClose } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import { UserNotificationsAlert } from '../UserNotificationsAlert/UserNotificationsAlert';
import ImageUploadProgress from '../../../utility/ImageUploadProgress/ImageUploadProgress'
const ChatMessage = () => {

    const dispatch = useDispatch();
    const { AuthInfo } = useSelector((state) => state?.auth);
    const { typingInfo } = useSelector(state => state.chat);
    const [messages, setMessages] = useState([]);
    const { data: userSingleData, error, isLoading } = useGetSingleUserDataQuery(AuthInfo?._id);


    const bottomRef = useRef(null);
    // let typingTimer = useRef(null);

    // First load → invisible instant scroll
    const [ScrollMessage, setScrollMessage] = useState([]);
    useEffect(() => {
        requestAnimationFrame(() => {
            bottomRef.current?.scrollIntoView({ behavior: "auto" });
        });
    }, []);

    // New messages → smooth scroll
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [ScrollMessage, typingInfo]);


    // conect message user

    useEffect(() => {
        if (!AuthInfo?.email) return;

        ChatService.register(AuthInfo.email, "user");

        ChatService.listen("connect", () => {
            ChatService.register(AuthInfo.email, "user");
        });

        return () => ChatService.remove("connect");
    }, [AuthInfo?.email]);




    useEffect(() => {
        initializeChatListeners(dispatch);
    }, []);


    useEffect(() => {

        // Typing events
        ChatService.listen("typing", (data) => {
            if (data.type === "admin") {
                dispatch(setTyping(data));
            }
        });

        ChatService.listen("stopTyping", (data) => {
            dispatch(stopTyping(data));
        });

        // Message receive
        ChatService.listen("message", (data) => {
            const newData = data?.message;
            // console.log(newData)
            if (newData) {
                setMessages(prev => {
                    const merged = [...prev, newData];
                    const unique = merged.filter(
                        (msg, index, self) =>
                            index === self.findIndex(m => m._id === msg._id)
                    );
                    return unique;
                });
                setScrollMessage(newData);
                if (newData?.adminId) {
                    ChatService.sendMessageSeen({
                        UserId: AuthInfo?._id,
                        type: "user"
                    });
                }
            }

        });

        // listenMessageSeen receive
        ChatService.listenMessageSeen(({ user, type }) => {
            const lastMessage = user?.lastMessage;
            // console.log(lastMessage)
            if (lastMessage && messages) {
                setMessages(prev => {
                    if (!Array.isArray(prev)) return prev;
                    const idx = prev.findIndex(m => m?._id === lastMessage._id);
                    if (idx === -1) return prev;

                    // replace
                    const updated = [...prev];
                    updated[idx] = lastMessage;
                    return updated;
                });
            }
        });

        return () => {
            ChatService.remove("onlineUsers");
            ChatService.remove("newUser");
            ChatService.remove("typing");
            ChatService.remove("stopTyping");
            ChatService.remove("message");
            ChatService.remove("removelistenMessageSeen");
        };
    }, []);



    useEffect(() => {
        ChatService.sendMessageSeen({
            UserId: AuthInfo?._id,
            type: "user"
        });
    }, [AuthInfo?._id]);



    const [ReplyData, setReplyData] = useState({});

    const handleReply = (data) => {
        setReplyData(data)
    };


    const [typingData, setTypingData] = useState("")
    const typingTimeout = useRef(null);

    const handleTyping = (e) => {
        const value = e.target.value;

        if (value) {
            ChatService.typing({ adminEmail: "", userEmail: userSingleData?.data?.email, type: "user" });

            if (typingTimeout.current) {
                clearTimeout(typingTimeout.current);
            }

            typingTimeout.current = setTimeout(() => {
                ChatService.stopTyping({ adminEmail: "", userEmail: userSingleData?.data?.email, type: "user" });
                typingTimeout.current = null;
            }, 1000);
        } else {
            ChatService.stopTyping({ adminEmail: "", userEmail: userSingleData?.data?.email, type: "user" });
            if (typingTimeout.current) {
                clearTimeout(typingTimeout.current);
                typingTimeout.current = null;
            }
        }
        setTypingData(value);
        e.target.style.height = "42px";
        e.target.style.height = `${e.target.scrollHeight}px`;
    };




    // message send 




    ///////////////////////   

    const [images, setImages] = useState([]);
    const fileInputRef = useRef(null);
    const [previews, setPreviews] = useState([]);
    const formRef = useRef(null);

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        // console.log(selectedFiles)

        const newFiles = selectedFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setPreviews((prev) => [...prev, ...newFiles]);
        setImages((prev) => [...prev, ...selectedFiles]);
        e.target.value = "";
    };

    const removeFile = (index) => {
        setPreviews((prev) => {
            const item = prev[index];

            if (item?.preview) {
                URL.revokeObjectURL(item.preview);
            }

            return prev.filter((_, i) => i !== index);
        });

        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    const clearPreviews = () => {
        setPreviews((prev) => {
            prev.forEach((item) => {
                if (item?.preview) {
                    URL.revokeObjectURL(item.preview);
                }
            });

            return [];
        });

        setImages([]);
    };



    const sendMessage = async () => {
        if (!typingData.trim() && images.length === 0) return;

        let uploadedUrls = [];

        if (images.length > 0) {
            const formData = new FormData();
            images.forEach((img) => {
                formData.append("images", img);
            });

            try {
                ImageUploadProgress.show();

                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/upload-images`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        onUploadProgress: (progressEvent) => {
                            if (!progressEvent.total) return;
                            const percent = Math.round(
                                (progressEvent.loaded * 100) /
                                progressEvent.total
                            );
                            ImageUploadProgress.update(percent, images);
                        },
                    }

                );
                if (res?.status === 200) {
                    uploadedUrls = res.data.urls;
                    clearPreviews();
                    ImageUploadProgress.success(
                        `${images.length} ${images.length === 1 ? "image" : "images"} uploaded successfully!`
                    );
                }

            } catch (error) {
                console.error("Upload failed:", error);
                ImageUploadProgress.error(
                    "Unable to upload images. Please try again."
                );
            }


        }

        ChatService.sendMessage({
            userId: AuthInfo?._id,
            senderId: AuthInfo?._id,
            from: AuthInfo?.email,
            text: typingData.trim(),
            image: uploadedUrls,
            replyId: ReplyData?._id,
            type: "user",
        });

        setTypingData("");
        setReplyData({});
    };




    const handleSendMessage = async (e) => {
        e.preventDefault();
        await sendMessage();
    }

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            if (!typingData.trim() && images?.length <= 0) return;
            await sendMessage();
        }
    }



    const [page, setPage] = useState(1);

    const { data: chatData, error: chatDataError, isLoading: ChatDataisLoading } = useGetChatDataQuery({
        userId: AuthInfo?._id,
        page,
    });


    // console.log(chatData)
    // Pagination buttons
    const handleNext = () => {
        if (page < chatData.totalPages) setPage(prev => prev + 1);
    };

    // Merge new page data with previous messages
    useEffect(() => {
        if (chatData?.data?.length) {
            setMessages((prev) => [...chatData.data, ...prev]);
        }
    }, [chatData]);

    useEffect(() => {
        if (chatData?.data?.length) {
            setScrollMessage([...chatData.data]);
        }
    }, [ChatDataisLoading]);


    const [modalShow, setModalShow] = useState(false);
    const [imageData, setImageData] = useState();

    const HandleShowImage = (data) => {
        setImageData(data)
        setModalShow(true);

    }




    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const profileMenuRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                profileMenuRef.current &&
                !profileMenuRef.current.contains(event.target)
            ) {
                setShowProfileMenu(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);


    if (isLoading) {
        return <></>;
    }
    return (
        <>

            <ImageModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                imageData={imageData}
            />

            <section className='live-chat-section'>
                <header className='live-chat-header'>
                    <div className="customer-support-section">
                        <div className="customer-support-left">
                            <div className="backbtn">
                                <a href="https://velormall.com"> <IoIosArrowBack /> </a>
                            </div>

                            <div className="customer-info">
                                <h3> Customer Support </h3>
                            </div>

                        </div>
                        <div className="customer-support-right" ref={profileMenuRef}>
                            <HiBars4 onClick={() => setShowProfileMenu((prev) => !prev)} />
                            {showProfileMenu && (
                                <div className="profile-dropdown">
                                    <div
                                        className="profile-dropdown-item"
                                        onClick={() => {
                                            setShowProfileMenu(false);
                                            UserNotificationsAlert(userSingleData?.data);
                                        }}
                                    >
                                        <span className="menu-icon">🔔</span>
                                        <span>Notification</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                <section className={`chat-messages-section ${images.length > 0 ? "bottom-160" : ""}`}  >
                    {/* Message Area */}

                    {chatData?.data?.length !== 0 && chatData?.page !== chatData?.totalPages && (<div className="chat-line" >
                        <span className="chat-date" onClick={handleNext}
                        >More</span>
                    </div>)}


                    {messages?.length !== 0 ? (
                        messages?.map((data, index) => {
                            if (data) {
                                return (
                                    <SingleItem
                                        data={data}
                                        index={index}
                                        key={index}
                                        handleReply={handleReply}
                                        HandleShowImage={HandleShowImage}
                                    ></SingleItem>
                                );
                            }
                        })
                    ) : (
                        <>
                        </>
                    )}


                    {typingInfo && (

                        <>
                            <div className="chats">
                                <div className="chat-content">
                                    <div className="message-content">
                                        <span className="animate-typing">is typing
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                            <span className="dot"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </>
                    )}

                    <div ref={bottomRef} ></div>
                </section>

                <footer>
                    <form onSubmit={handleSendMessage} ref={formRef} className='chat-input-form-area'>
                        {/* Image Preview */}
                        {previews.length > 0 && (
                            <div className="image-preview-section">

                                {previews.map((item, index) => (
                                    <div className="image-preview" key={index}>
                                        <img src={item.preview} alt="preview" />

                                        <button
                                            type="button"
                                            className="remove-image"
                                            onClick={() => removeFile(index)}
                                        >
                                            <IoClose size={14} />
                                        </button>
                                    </div>
                                ))}

                                {/* Add More */}
                                <button
                                    type="button"
                                    className="add-image"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <FiPlus size={30} />
                                </button>

                            </div>
                        )}

                        <section className='chat-input-secton'>

                            <div className="chat-input-left">
                                {/* <textarea name="" id=""></textarea> */}

                                <div className="form">

                                    <textarea
                                        value={typingData}
                                        onChange={handleTyping}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Type here and press enter.."
                                        className="input textarea"
                                    />
                                </div>
                            </div>

                            <div className="chat-input-right">

                                <div style={{
                                    display:
                                        typingData.trim() === "" && images?.length === 0
                                            ? "block"
                                            : "none",
                                }}>

                                    <div className="file-input-are">
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            multiple
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                        />

                                        <GrAttachment
                                            size={20}
                                            className="attachment-icon"
                                            onClick={() => fileInputRef.current?.click()}
                                        />
                                    </div>

                                </div>

                                <div style={{
                                    display:
                                        typingData.trim() !== "" || images?.length !== 0
                                            ? "block"
                                            : "none",
                                }}>

                                    <div className="send-btn">
                                        <button type="submit">
                                            <LuSendHorizontal />
                                        </button>
                                    </div>

                                </div>

                                {/* {typingData.trim() === "" ? (
                                    <div className="file-input-are">
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            multiple
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                        />

                                        <GrAttachment
                                            size={20}
                                            className="attachment-icon"
                                            onClick={() => fileInputRef.current?.click()}
                                        />
                                    </div>
                                ) : (
                                    <div className="send-btn">
                                        <button type="submit">
                                            <LuSendHorizontal />
                                        </button>
                                    </div>
                                )} */}


                            </div>


                        </section>
                    </form>


                </footer>


            </section>


        </>
    )
}

export default ChatMessage;